export default "__VITE_ASSET__DSThY$5z__"